import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface MonthRate {
  month: string;
  rate: number;
  trend: 'up' | 'down' | 'stable';
}

// Mock data - será substituído por dados reais
const MOCK_RATES: MonthRate[] = [
  { month: 'Jan', rate: 78.5, trend: 'up' },
  { month: 'Fev', rate: 82.3, trend: 'up' },
  { month: 'Mar', rate: 79.1, trend: 'down' },
  { month: 'Abr', rate: 85.7, trend: 'up' },
  { month: 'Mai', rate: 84.2, trend: 'down' },
  { month: 'Jun', rate: 87.4, trend: 'up' },
];

const trendIcons = {
  up: TrendingUp,
  down: TrendingDown,
  stable: Minus,
};

const trendColors = {
  up: 'text-[hsl(var(--accent-600))]',
  down: 'text-[hsl(var(--careful-600))]',
  stable: 'text-muted-foreground',
};

export function ReceivingRateTable() {
  const currentRate = MOCK_RATES[MOCK_RATES.length - 1];
  const avgRate = (MOCK_RATES.reduce((sum, r) => sum + r.rate, 0) / MOCK_RATES.length).toFixed(1);

  return (
    <div className="p-5 rounded-2xl border bg-card hover:shadow-lg transition-all duration-300">
      <div className="mb-4">
        <h3 className="text-sm font-semibold text-foreground">Taxa de Recebimento</h3>
        <p className="text-xs text-muted-foreground">Últimos 6 meses</p>
      </div>
      
      {/* Current Rate Highlight */}
      <div className="mb-4 p-4 rounded-xl bg-gradient-to-r from-[hsl(var(--accent-50))] to-[hsl(var(--basic-50))] border border-[hsl(var(--accent-100))]">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs text-muted-foreground">Taxa Atual ({currentRate.month})</p>
            <p className="text-2xl font-bold text-[hsl(var(--accent-700))]">{currentRate.rate}%</p>
          </div>
          <div className="text-right">
            <p className="text-xs text-muted-foreground">Média do Período</p>
            <p className="text-lg font-semibold text-foreground">{avgRate}%</p>
          </div>
        </div>
      </div>

      {/* Monthly Rates Table */}
      <div className="space-y-2">
        {MOCK_RATES.map((monthData) => {
          const TrendIcon = trendIcons[monthData.trend];
          return (
            <div 
              key={monthData.month}
              className="flex items-center justify-between py-2 px-3 rounded-lg hover:bg-muted/30 transition-colors"
            >
              <span className="text-xs font-medium text-foreground w-8">{monthData.month}</span>
              
              <div className="flex-1 mx-3">
                <div className="h-2 bg-muted rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-[hsl(var(--basic-500))] rounded-full transition-all"
                    style={{ width: `${monthData.rate}%` }}
                  />
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <span className="text-xs font-bold text-foreground w-12 text-right">
                  {monthData.rate}%
                </span>
                <TrendIcon className={cn('h-3 w-3', trendColors[monthData.trend])} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
